import { Modal } from "flowbite-react";
import { IRenter } from "../../../../../../types/renter.type";
import UnlinkVehicleModal from "./formsModal/UnlinkVehicleModal";
import { IVehicleVisualRecord } from "@/types/vehicle-visual-record.type";
import { useEffect, useState } from "react";
import { findRepossessionByVehicleAndRenter } from "@/common/services/repossession.api";
import { partsEvaluationData } from "@/common/helpers/partsEvaluationData";
import { FormikProvider, useFormik } from "formik";

type Props = {
  onClose: () => void;
  data: IRenter;
  register: IVehicleVisualRecord[];
  vehicleId: string;
};

type Photo = {
  type: string;
  content: string;
};

interface IFormValues {
  renterId?: string;
  renterName: string;
  licensePlate: string;
  vehicle: {
    _id: string;
  };
  registers: Photo[];
  returnReason: string;
  optionRepossesion: string;
  partsEvaluation: { [key: string]: boolean };
}

const registerProps = [
  { type: "Frente do veículo", content: "" },
  { type: "Lateral direita do veículo", content: "" },
  { type: "Lateral esquerda do veículo", content: "" },
  { type: "Traseira do veículo", content: "" },
  { type: "Odômetro", content: "" },
];

export function EditUnlinkBond(props: Props) {
  const { data: renter, vehicleId, register } = props;
  const [initialFormValues, setInitialFormValues] = useState<IFormValues>({
    renterId: renter._id,
    renterName: renter.name,
    licensePlate: renter.activationData?.vehicle.licensePlate,
    vehicle: {
      _id: renter.activationData?.vehicle.id,
    },
    registers: [],
    returnReason: "",
    optionRepossesion: "",
    partsEvaluation: {},
  });

  const formik = useFormik({
    initialValues: initialFormValues,
    enableReinitialize: true,
    onSubmit: async (data) => {
      data;
    },
  });

  const handleCloseModal = () => {
    props.onClose();
  };

  useEffect(() => {
    const fetchDataAndPrepareForm = async () => {
      if (!renter?._id) {
        console.error(
          "ID do cliente (renter) não encontrado. Abortando busca."
        );
        return;
      }
      const { data, ok } = await findRepossessionByVehicleAndRenter({
        vehicleId: vehicleId,
        renterId: renter._id,
      });

      const newPartsEvaluation = {};

      if (ok && data) {
        const repossession = data;

        const newOptionRepossesion = repossession.reason || "";
        const evaluationNote = repossession.notes.find((note) =>
          note.text.includes("--- Avaliação de Peças ---")
        );

        if (evaluationNote) {
          const partsText = evaluationNote.text.split(
            "--- Avaliação de Peças ---"
          )[1];

          if (partsText) {
            const partsArray = partsText
              .split("-")
              .filter((p) => p.trim() !== "");

            partsArray.forEach((partString) => {
              const [partLabel, status] = partString.split(": ");

              if (partLabel && status) {
                const partConfig = partsEvaluationData.find(
                  (p) => p.name.trim() === partLabel.trim()
                );
                if (partConfig) {
                  newPartsEvaluation[partConfig.name] =
                    status.trim() === "Avariado";
                } else {
                  console.warn(`Peça "${partLabel.trim()}" não encontrada!`);
                }
              }
            });
          }
        }
        const registers = Array.isArray(register) ? register[0] : register;

        const deliveryPhotos = registers.photos?.devolutionPhotos || [];

        setInitialFormValues((prevValues) => ({
          ...prevValues,
          partsEvaluation: newPartsEvaluation,
          optionRepossesion: newOptionRepossesion,
          returnReason: registers.returnReason,
          registers: deliveryPhotos.length > 0 ? deliveryPhotos : registerProps,
        }));
      } else {
        setInitialFormValues((prevValues) => ({
          ...prevValues,
          registers: registerProps,
        }));
      }
    };

    fetchDataAndPrepareForm();
  }, [vehicleId, renter._id, register]);

  return (
    <Modal
      className='relative text-black dark:text-black'
      size="5xl"
      show={true}
      onClose={() => handleCloseModal()}>
      <Modal.Header className=" h-12 items-center dark:text-black">
        <span className="dark:text-black">Desvincular Veículo</span>
      </Modal.Header>
      <Modal.Body
        className='w-full relative border-gray flex flex-col p-0'
        style={{ minHeight: 'auto' }}>
        <section>
          <div className="py-4">
            <FormikProvider value={formik}>
              <UnlinkVehicleModal data={renter} />
            </FormikProvider>
          </div>
        </section>
      </Modal.Body>
      <Modal.Footer className="justify-end h-20 ">
        <button
          className="bg-redPrimary text-white font-semibold p-2 w-[100px] rounded-md mb-2 my-4 justify-end"
          type="button"
          onClick={() => handleCloseModal()}
        >
          Fechar
        </button>
      </Modal.Footer>
    </Modal >
  );
}
